<template>
  <output-preset-details
    v-if="!fetchingOutputPreset && !fetchingEmptyOutputPreset"
  />
  <loading-page v-else />
</template>

<script>
import { mapGetters } from 'vuex'
import OutputPresetDetails from './view/OutputPresetDetails.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'EditOutputPreset',
  components: { OutputPresetDetails },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('outputPresets', [
      'fetchingOutputPreset',
      'fetchingEmptyOutputPreset',
    ]),
  },
  created() {
    this.getOutputPreset()
    this.getEmptyPreset()
  },
  methods: {
    getOutputPreset() {
      this.$store
        .dispatch('outputPresets/getOutputPresetById', this.$route.params.id)
        .catch(err => redirectError(err, this.$router, this.$route.path))
    },
    getEmptyPreset() {
      this.$store
        .dispatch('outputPresets/getEmptyOutputPreset')
        .catch(err => redirectError(err, this.$router, this.$route.path))
    },
    init() {
      this.getEmptyPreset()
      this.getOutputPreset()
    },
  },
}
</script>
